import logger from "../common/Logger";
import ApiService from "./ApiService";
import SiteService from "./SiteService";

class LogService {
    constructor() {
        this.fetchLogEndpoint = this.fetchLogEndpoint.bind(this);
    }

    /**
     * Fetch the log endpoint to use.
     *
     * @param tenantId {string}
     * @param options {{success: function, error: function}}
     */
    fetchLogEndpoint(tenantId, options) {
        const tenantType = SiteService.getTenantType();
        ApiService.makeRequest(`/api/logs/${tenantType}/${tenantId}`, {
            type: "GET",
            success(logEndpoint) {
                logger.debug(`Retrieved logs endpoint: ${logEndpoint.url}`);
                options.success(logEndpoint);
            },
            error(result, err) {
                if (err) logger.error(err);
                options.error(err)
            }
        });
    }
}

export default LogService;



// WEBPACK FOOTER //
// ./src/modules/service/LogService.js